let baseURL = 'https://api.edamam.com/search';
const apiID = 'f3d01c62'
const apiKey = '7295ecb61b769375ba42bc6b35260fd4'


const urls = {

}


export {urls, baseURL, apiID, apiKey}
